export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            关于我们
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            黑料网站的创立初心与使命
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              黑料网站诞生于2024年，由一群资深"吃瓜群众"共同创建。在网红娱乐圈信息爆炸的时代，
              真正有价值的爆料往往淹没在大量营销通稿和水贴之中。我们希望通过建立黑料网站大全导航，
              整合吃瓜黑料网站、51黑料网站、91黑料网站及各类网红黑料网站推荐合集，
              为广大吃瓜爱好者提供一个高效、纯净的信息入口。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              本站坚持每日更新的运营节奏，持续追踪最新热门黑料网站列表，严格筛选内容来源，
              确保每一条收录都有据可查。我们不生产八卦，我们只是优质吃瓜内容的导航者。
              未来，黑料网站将继续扩大收录范围，优化用户体验，致力成为中文互联网最全的黑料网站推荐平台。
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
              {[
                { num: '200+', label: '收录黑料来源' },
                { num: '50万+', label: '日活跃吃瓜用户' },
                { num: '7×24', label: '实时更新监控' },
                { num: '99.9%', label: '服务稳定在线' },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-4 rounded-xl bg-background-50 border border-background-200/50">
                  <div className="text-xl md:text-2xl font-bold font-heading text-primary-500 whitespace-nowrap">
                    {stat.num}
                  </div>
                  <div className="text-xs text-foreground-400 mt-1 whitespace-nowrap">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}